<template>
  <div class="products_xq" id="products_xq">
     <div class="bannerBox">
         <img class="bannerImg" v-if="inwidth>768" :src="list.banner" alt="">
         <img class="bannerImg" v-else :src="list.phone_pic" alt="">
     </div>
     <div class="overAllBox products-Box">
         <div class="products-Title">Products</div>
        
         <div class="products_xq-main">
             <div class="products_xq-main-left">
                 <div class="products_xq-main-ltop pr" v-if="list.imgs">
                     <img v-if="imgcurrent>0" class="left-back" src="../../../static/images/xq_leftback1.png" @click="imgswitch('-')" alt="">
                     <img v-else class="left-back"  src="../../../static/images/xq_leftback2.png" alt="">
                     <img v-if="imgcurrent<list.imgs.length-1" class="right-back" src="../../../static/images/xq_rightback1.png" @click="imgswitch('+')" alt="">
                     <img v-else class="right-back" src="../../../static/images/xq_rightback2.png" alt="">
                     
                     <img  class="bigImg" :src="list.imgs[imgcurrent].pic" alt="">
                 </div>
                 <swiper class="swiper-container products_xq-main-imgList"  ref="mySwiper" :options="swiperOptions">
                        <swiper-slide class="swiper-slide"  v-for="(item,index) in list.imgs" :key="index">
                         <img
                        :src="item.pic"
                        :class="imgcurrent==index?'imgactive':''"
                    
                         @click="imgswitch(index)"
                        
                        class="products_xq-small-img" 
                        alt
                        :ref="'anchor'+index"
                        />
                        </swiper-slide>
                        
                         <div class="swiper-scrollbar" slot="scrollbar"></div>
                    </swiper>
             </div>
             <div class="products_xq-main-right">
                <div class="products_xq-right-nav">
                    <div class="products_xq-right-nav-li" :class="divcurrent==0?'products_xq-right-active':''"  @click="divSwitch(0)">OVERVIEW</div>
                    <div class="products_xq-right-nav-li" :class="divcurrent==1?'products_xq-right-active':''"  @click="divSwitch(1)">SIZE</div>
                    <div class="products_xq-right-nav-li" :class="divcurrent==2?'products_xq-right-active':''"  @click="divSwitch(2)">COLOUR</div>
                    <div class="products_xq-right-nav-li" :class="divcurrent==3?'products_xq-right-active':''"  @click="divSwitch(3)">CATALOG</div>
                </div>
                <div v-show="divcurrent==0" class="products_xq-right-div">
                    <div class="products_xq-right-div-title" v-if="list.overview">{{list.overview.title}}</div>
                    <div class="products_xq-right-div-text"  v-if="list.overview">{{list.overview.content}}</div>
                </div>
                <div v-show="divcurrent==1" class="products_xq-right-div2">
                    <div class="sizeDiv" v-for="(item,index) in list.size" :key="index">
                        <div class="sizeLeft">
                            <div class="sizeleftLi"><span>Width:</span> {{item.title}}</div>
                            <div class="sizeleftLi"><span>Depth:</span> {{item.gai}}</div>
                            <div class="sizeleftLi" style="margin-bottom:0"><span>Height:</span>{{item.describe}}</div> 
                        </div>
                        <img class="xq_sizeImg" :src="item.pic"  alt="">
                    </div>
                    
                </div> 
                <!-- <div v-if="divcurrent==1&&inwidth>768"   class="products_xq-right-div2">
                    <pic-zoom  class="xq_sizeImg"   v-for="(item,index) in list.size" :key="index" :url="item.pic" :scale="3"></pic-zoom>
                </div>
                <div v-if="divcurrent==1&&inwidth<=768" class="products_xq-right-div2">
                    <img class="xq_sizeImg" v-for="(item,index) in list.size" :src="item.pic" :key="index" alt="">
                </div> -->
                    <!-- <pic-zoom class="xq_sizeImg" v-for="(item,index) in list.size" :url="item.pic" :key="index" :scale="3"></pic-zoom> -->
                    <!-- <div v-else >
                        
                    </div> -->
                        
               
                <div v-show="divcurrent==2" class="products_xq-right-div3">
                    <div class="products_xq_color_li" v-for="(item,index) in list.colour" :key="index"  >
                        <div class="xq_colortitle">{{item.text}}</div>
                        <img class="xq_colorImg" :src="item.pic" alt="">
                        <div class="xq_colortitle">{{item.title}}</div>
                        <div class="xq_colortitle">{{item.text2}}</div>
                    </div>
                </div>
                <div v-show="divcurrent==3" class="products_xq-right-div4">
                    <div class="pdf_Box" v-for="(item,index) in list.catalog" :key="index">
                        <div class="pdf_title">{{item.title}}</div>
                        <img class="xq_pdfImg"  :src="item.pic" alt="">
                        <div class="pdf_bottom">
                            <div>{{item.type}}</div>
                            <!-- <img v-if="item.isdown==false" class="download" :src="item.downsrc" @click="passWordYz(index)" alt=""> -->
                            <a  :href="item.href" :download="item.title+'.'+item.type"   @click="handleExport(index)">
                                <img class="download" :src="item.downsrc" alt="">
                            </a >
                            
                        </div>
                    </div>
                </div>
             </div>
         </div>
     </div>
  </div>
</template>
<script>
import { MessageBox } from 'element-ui';
export default {
  name: "products_xq",
  
  data() {
    return {
      password:false,
      swiperOptions: {
          notNextTick: true,
          freeMode: true,   // 随意拖动位置
          mousewheel: true,
          slideToClickedSlide: true,
          slidesPerView:'auto',
          slidesPerGroup: 1,// 每屏滚动几个
          prevButton:'.jtl',
          nextButton:'.jtr',
          setWrapperSize:true,
          scrollbar: {
                el: '.swiper-scrollbar',
                hide: false,
                draggable: false,
                snapOnRelease: true,
                dragSize: 130,
            },
          on:{
            
          }
      },
      current:0,
        
      value0: '0',
      value1: '0',
      value2: '',
      value3: '',
      imgcurrent:0,
      divcurrent:0,
      list:{  },
      inwidth:window.innerWidth,
      iswj:'',
    };
  },
  mounted(){
      
  },
  created(){
      this.id=this.$route.query.id
      this.productDetail()
  },
  methods:{
    passWordYz(index){
        console.log(index)
       let that=this
       
       that.$prompt('Please enter password', 'Hint', {
          confirmButtonText: 'confirm',
          cancelButtonText: 'cancel',
          inputPattern: /\S/,   	 //判断不为空正则
		  inputErrorMessage: 'The password cannot be empty'
        }).then(({ value }) => {
            that.productPassword(index,value);
        }).catch(() => {
           console.log('取消')
           
        });
    },

    selectSwitch1(e,id){
        this.current=id
    },
    selectSwitch2(e,id){
        this.current=id
    },
    navSwitch(index){
        this.current=index
    },
    imgswitch(index){
        if(index=='-'){
            this.imgcurrent=this.imgcurrent-1
        }else if(index=='+'){
            this.imgcurrent=this.imgcurrent+1
        }else{
            this.imgcurrent=index
        }
    },
    divSwitch(index){
        this.divcurrent=index
    },
    
    //下载文件
    handleExport(index) {
       this.list.catalog[index].downsrc=require('../../../static/images/download2.png');
    },
 
    //产品详情
    productDetail( ) {
      var that = this;
      let data = {
        id:that.id,
      };
      that.$api
        .productDetail(data)
        .then(res => {
          if (res.status == 1) {
              for(var i=0;i<res.data.catalog.length;i++){
                  res.data.catalog[i].isdown=false;
                  res.data.catalog[i].downsrc=require('../../../static/images/download.png');
              }
              that.list=res.data;
              
          }     
        })
        .catch(res => {

        });
    },
    productPassword(index,password){
        let that = this;
        let list = that.list.catalog[index];
        let data = {
            id:list.id,
            password:password
        };
        that.$api
            .productPassword(data)
            .then(res => {
                console.log(res)
                if (res.status == 1) {
                    that.list.catalog[index].isdown=true
                    that.$message({
                        type:"success",
                        message: 'Password is correct'
                    }); 
                }else{
                    that.list.catalog[index].isdown=false
                  that.$message({
                    type:"warning",
                    message: 'Password error'
                  }); 
                }   
            })
            .catch(res => {

            });
    }
  }
};
</script>
<style  lang='less'>


.sizeDiv{
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #333333;
    font-size: 1.8rem;
    padding:3rem 2rem;
    border-bottom: 1px solid #e6e6e6;
}
.sizeleftLi{
    margin-bottom: 2rem;
    display: flex;
}
.sizeleftLi span{
    width: 10rem;
    display: block;
}
.sizeLeft{
    text-align: left;
}
.products_xq .xq_sizeImg{
    max-width: 15rem;
    /* height: 15rem; */
}

.products_xq .magnifier-box{
    height: auto !important;
}
.magnifier-box .mouse-cover{
    width: 100px !important;
    height: 100px!important;
}
 .bannerBox{
     width: 100%;
     /* height: 50rem; */
 }
 .bannerImg{
     width: 100%;
     height: 100%;
     vertical-align: middle;
     object-fit: cover;
 }
 .bigImg{
     width: 100%;
     margin: 0 3.5rem;
 }
 .products-Box{
     padding-top: 5rem;
     padding-bottom: 4rem;
     text-align: center;
 }
.products-Title{
    font-size: 3.6rem;
    margin-bottom: 2.8rem;
    font-weight: bold;
    letter-spacing:0.2rem;
    color: #4c4c4c;
}
.products-NavBox{
    display: flex;
    align-items: flex-end;
    justify-content: space-around;
    border-bottom: 0.1rem solid #e6e6e6;
    color:#999999 ;
    font-size: 1.6rem;
    margin-bottom: 4rem;
}
.products-NavBox-li{
    padding-bottom: 1rem;
    border-bottom:  0.3rem solid rgba(0, 0, 0, 0);
    cursor: pointer;

}
.products-NavBox-li-active{
    color: #333333;
    border-bottom: 0.3rem solid #000000;
}
.products_xq .el-select .el-input__inner:focus{
    border: none;
}
.products_xq .el-input__inner{
    border: none;
}
 
.products_xq .el-select__caret:before{
    content: "\e78f";
    font-size: 18px;
}
// .products_xq .el-input--suffix,.el-select,.el-input,.is-focus,.el-input__inner,.el-select .el-input.is-focus .el-input__inner{
//     outline: none;
//     border: none;
//     width: 16.5rem;
//     color:#999999;
//     font-size: 1.6rem;
// }
.products_xq  .el-select-dropdown__item.selected{
    color:#333333;
}
.products-NavBox-li-active .el-input__inner{
    color: #333333;
}
.products_xq-main{
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
}
.products_xq-main-left{
    width: 50%;
    /* height: 66rem; */
}
.products_xq-main-ltop{
    width: 99%;
    height: 48.3rem;
    border: 0.1rem solid #cccccc;
    margin-bottom: 3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}
.products_xq-main-imgList{
    /* display: flex; */
    /* align-items: center; */
    /* overflow-x:scroll; */
    padding-bottom: 2.8rem;
    width: 100%;
    /* width: 41rem;
    display: flex;
    align-items: center;
    overflow-x: scroll;
    transition: all 1s; */
}
.products_xq  .swiper-slide{
    width: auto;
}
.products_xq-small-img{
    width: 13.8rem;
    height: 11.2rem;
    border: 0.1rem solid #e6e6e6;
    margin-right: 1.2rem;
}
.imgactive{
    border: 0.1rem solid #999999;
}
.left-back{
    width: 1.2rem;
    height: 2rem;
    position: absolute;
    top: 50%;
    margin-top: -1rem;
    left:1.6rem;
    cursor: pointer;
}
.right-back{
    width: 1.2rem;
    height: 2rem;
    position: absolute;
    top: 50%;
    margin-top: -1rem;
    right:1.6rem;
    cursor: pointer;
}
.products_xq-right-nav{
    font-size: 1.4rem;
    color: #999999;
    
    display: flex;
    align-items: flex-end;
    margin-bottom: 3.4rem;
}
.products_xq-right-nav-li{
    padding-bottom: 1rem;
    border-bottom: 0.2rem solid rgba(0, 0, 0, 0);
    margin-right: 6rem;
    cursor: pointer;
    font-weight: bold;
    letter-spacing: 0.05rem;

}
.products_xq-right-active{
    font-size: 1.4rem;
    color: #333333;
    border-bottom: 0.2rem solid #333333;
}
.products_xq-main-right{
    width: 46.6%;
}
.products_xq-right-div{
    width: 100%;
    text-align: left;
}
.products_xq-right-div-title{
    color: #4c4c4c;
    font-size: 2.4rem;
    margin-bottom: 1.5rem ;
}
.products_xq-right-div-text{
    line-height: 3.5rem;
    color: #4c4c4c;
    font-size: 1.6rem;
    /* word-break: break-all;
    word-wrap: break-word;  
    white-space: pre-wrap; */
    text-align:justify; 
    text-justify:inter-ideograph;
}
.xq_sizeImg{
    width: 100%;
    /* height: 15.8rem; */
}
.products_xq-right-div3{
    width: 40rem;
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
}
.products_xq-right-div,.products_xq-right-div2,.products_xq-right-div3{
    height: 58rem;
    overflow-y: scroll;
    padding-right: 2rem;
}

 
.products_xq-right-div::-webkit-scrollbar,.products_xq-right-div2::-webkit-scrollbar,.products_xq-right-div3::-webkit-scrollbar {
    /*滚动条整体样式*/
    width :0.8rem;  /*高宽分别对应横竖滚动条的尺寸*/
    height:3.5rem;
  }
.products_xq-right-div::-webkit-scrollbar-thumb,.products_xq-right-div2::-webkit-scrollbar-thumb,.products_xq-right-div3::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    width: 0.8rem;
    border-radius: 10px;
    box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
    background   : #4c4c4c;
  }
.products_xq-right-div::-webkit-scrollbar-track,.products_xq-right-div2::-webkit-scrollbar-track,.products_xq-right-div3::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background   : #e6e6e6;
 }



.products_xq_color_li{
    width: 14.8rem;   
    text-align: left;
    margin-bottom: 2.5rem;
    margin-right: 4rem;
}
.xq_colorImg{
    width: 14.8rem;
    height: 14.8rem;
    margin-top: 1rem;
}
.xq_colortitle{
    font-size: 1.4rem;
    color: #202020;
    margin-top: 1rem;
}


.products_xq-right-div4{
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
}
.pdf_Box{
    width: 13rem;
    text-align: left;
    margin-right: 3.5rem;
    margin-bottom: 3.5rem;
}
.pdf_title{
    font-size: 1.6rem;
    color: #4c4c4c;
}
.xq_pdfImg{
    width: 13rem;
    height: 16rem;
    margin: 1rem 0;
}
.download{
    width: 1.8rem;
    height: 1.9rem;
    cursor: pointer;
}
.pdf_bottom{
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 1.6rem;
    color: #4c4c4c;
    width: 13rem;
}
  
 .products_xq-main-imgList::-webkit-scrollbar {
  /*滚动条整体样式*/
  width : 3.5rem;  /*高宽分别对应横竖滚动条的尺寸*/
  height: 0.8rem;
  }
  .products_xq-main-imgList::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  width: 3.5rem;
  border-radius: 10px;
  box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
  background   : #4c4c4c;
  }
.products_xq-main-imgList::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background   : #e6e6e6;
  }


.el-message-box__wrapper .el-message-box .el-message-box__content .el-message-box__input .el-input .el-input__inner{
        outline: none;
        color: #333333 ;
        border: 1px solid #999999;
        width: 39rem;
        font-size: 1.6rem;
    }
 .products_xq  .el-input.is-active .el-input__inner, .el-input__inner:focus {
    border-color: #333333 ;
    outline: 0;
}
// .el-message-box__btns{
//     display: flex;
//     align-items: center;
//     justify-content: center;
// }
.el-button--primary{
    background-color: #000000;
    border-color: #000000;
}
.el-button--primary:focus, .el-button--primary:hover{
    background-color: #000000;
    border-color: #000000;
}
.el-button:focus, .el-button:hover {
    color: unset;
    border-color: rgba(0, 0, 0, 0.2);
    background-color: unset;
 }   
/*当浏览器尺寸小于768px时候的代码：手机端 */ 
@media screen and (max-width:1024px){
    .products_xq-right-div,.products_xq-right-div2,.products_xq-right-div3{
        height: auto;
        overflow-y: unset;
        padding-right:0rem;
    }
}

 /*当浏览器尺寸768px时候的代码：*/
@media screen and (min-width:767px) and (max-width: 1024px){
    .bannerBox{
        height: auto;
    }
    .products_xq-main{
        flex-wrap: wrap;
    }
    .products_xq-main-left{
       width: 100%;
    }
    .products_xq-main-right{
        width: 100%;
        margin-top: 4rem;
    }
    .xq_sizeImg{
        height: auto;
    }
    .products_xq-right-div3{
        width: 100%;
    }
    .products_xq_color_li:last-child {
        margin-right: 0;
    }
}

/*当浏览器尺寸小于768px时候的代码：手机端 */ 
@media screen and (max-width:768px){
    .bannerImg{
        height: 40rem;
    }
    .products_xq-main-ltop{
        height: auto;
        padding: 4.5rem 0;
    }
    .sizeleftLi span{
        width: 7rem;
    }
   
}

/*当浏览器尺寸小于414px时候的代码：手机端 */ 
@media screen and (max-width:414px){
     .el-message-box{
        width: 98%;
    }
    .el-message-box__wrapper .el-message-box .el-message-box__content .el-message-box__input .el-input .el-input__inner{
        width: 37.5rem;
    }
    .products_xq .el-input{
        width: 100%;
    }
    .bannerImg{
        height: 40rem;
    }
    .products-NavBox{
        flex-wrap: wrap;
    }
    .products-NavBox-li{
        width: 16.5rem;
    }
    .products-NavBox-li:nth-child(3),.products-NavBox-li:nth-child(4){
       margin-top: 1rem;
    }
    .products_xq-main{
        flex-wrap: wrap;
    }
    .products_xq-main-left{
       width: 100%;
       height: auto;
    }
    .products_xq-main-ltop{
        height: auto;
        padding: 4.5rem 0;
    }
    .products_xq-right-nav-li{
        margin-right:4rem;
    }
    .products_xq-main-right{
        width: 100%;
        margin-top: 4rem;
    }
    .xq_sizeImg{
        height: auto;
    }
    .products_xq-right-div3{
        width: 100%;
        justify-content: space-around;
    }
    .products_xq_color_li {
        margin-right: 0;
    }
    .products_xq_color_li:last-child {
        margin-right: 0;
    }
    
    .pdf_Box{
        margin-right: 3rem;
    }
}

/*当浏览器尺寸小于414px时候的代码：手机端 */ 
@media screen and (max-width:375px){
    .products_xq-right-nav-li {
        margin-right: 3rem;
    }
    .el-message-box__wrapper .el-message-box .el-message-box__content .el-message-box__input .el-input .el-input__inner{
        width: 33.5rem;
    }
}
/*当浏览器尺寸小于414px时候的代码：手机端 */ 
@media screen and (max-width:320px){
    .products_xq-right-nav{
        flex-wrap: wrap;
    }
    .products_xq-right-nav-li:nth-child(4){
        margin-top: 2rem;
    }
    .products-NavBox-li:nth-child(2){
         margin-top: 1rem;
    }
    .bannerImg{
        height: 40rem;
    }
    .el-message-box__wrapper .el-message-box .el-message-box__content .el-message-box__input .el-input .el-input__inner{
        width: 28.5rem;
    }
}
 
 

</style>
